/**
 * Cart Drawer - Vaillant Parfums
 * Version: 3.0 - DESIGN ÉPURÉ
 */

/* ========================================
   CONFIGURATION
   ======================================== */

if (typeof window.INSURANCE_CONFIG === 'undefined') {
  window.INSURANCE_CONFIG = {
    variantId: '48928353845575',
    price: 490,
    productHandle: 'assurance-laposte'
  };
}

if (typeof window.UPSELL_CONFIG === 'undefined') {
  window.UPSELL_CONFIG = {
    // Paid "Standard" variant. ID changed when the "Offert" (free gift) variant
    // was added to the Kit Prestige product (Shopify recreated the variants).
    variantId: '54133873606983',
    productId: '10546226397511',
    productHandle: 'kit-prestige',
    price: 2495
  };
}

/* ========================================
   CART DRAWER CLASS
   ======================================== */

if (!customElements.get('cart-drawer')) {

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.initAllFeatures();
  }

  initAllFeatures() {
    this.initTimer();
    this.initReviewCarousel();
    this.initInsuranceToggle();
    this.initUpsellToggle();
    this.initQuantityButtons();
    this.bindOverlay();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.onclick = () => this.close();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    if (!this.classList.contains('active')) {
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          
          if (typeof trapFocus === 'function') {
            trapFocus(containerToTrapFocusOn, focusElement);
          }
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }
    
    this.initAllFeatures();
  }

  close() {
    this.classList.remove('active');
    
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    
    this.productId = parsedState.id;
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.initAllFeatures();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* ========================================
     GESTION DES QUANTITÉS
     ======================================== */

  initQuantityButtons() {
    const quantityContainers = this.querySelectorAll('.cart-quantity');
    
    quantityContainers.forEach(container => {
      const minusBtn = container.querySelector('[name="minus"]');
      const plusBtn = container.querySelector('[name="plus"]');
      const input = container.querySelector('.quantity__input');
      
      if (!input) return;
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';
      
      if (minusBtn) {
        minusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || 1;
          const newValue = Math.max(0, currentValue - 1);
          input.value = newValue;
          this.updateCartQuantity(input);
        });
      }
      
      if (plusBtn) {
        plusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || 0;
          input.value = currentValue + 1;
          this.updateCartQuantity(input);
        });
      }
      
      input.addEventListener('change', () => this.updateCartQuantity(input));
    });
  }

  async updateCartQuantity(input) {
    const index = input.dataset.index;
    const quantity = parseInt(input.value);
    
    const cartItem = input.closest('.cart-item');
    if (cartItem) cartItem.classList.add('cart-item--loading');
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(index), quantity })
      });
      
      if (!response.ok) throw new Error('Erreur réseau');
      await this.updateDrawerContent();
      
    } catch (error) {
      console.error('Erreur:', error);
      if (cartItem) cartItem.classList.remove('cart-item--loading');
    }
  }

  /* ========================================
     MISE À JOUR DRAWER
     ======================================== */

  /**
   * Verrou de rendu.
   *
   * Plusieurs sources peuvent demander un rafraîchissement au même instant
   * (boutons quantité, free-gift.js, wrapper Fix 1.1, sticky-atc). Sans verrou,
   * deux rendus qui se croisent produisent innerHTML=B, reinit_B, puis reinit_A
   * qui rebinde les mêmes noeuds : double listener sur les boutons de quantité
   * (un clic = deux /cart/change) et double carouselInterval.
   *
   * `queued` est indispensable : une demande arrivée pendant un rendu correspond
   * à un panier plus récent, la laisser tomber figerait un état périmé.
   */
  async updateDrawerContent() {
    if (this._renderBusy) {
      this._renderQueued = true;
      return this._renderPromise;
    }

    this._renderBusy = true;
    this._renderPromise = this._doRenderDrawer().then(() => {
      this._renderBusy = false;
      if (this._renderQueued) {
        this._renderQueued = false;
        return this.updateDrawerContent();
      }
    });

    return this._renderPromise;
  }

  async _doRenderDrawer() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await response.json();
      
      const cartDrawerElement = document.getElementById('CartDrawer');
      if (cartDrawerElement && sections['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawerInner = doc.querySelector('.drawer__inner');
        const currentDrawerInner = cartDrawerElement.querySelector('.drawer__inner');
        
        if (newDrawerInner && currentDrawerInner) {
          const cartItems = this.querySelector('cart-drawer-items');
          const scrollTop = cartItems ? cartItems.scrollTop : 0;
          
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          
          const newCartDrawer = doc.querySelector('cart-drawer');
          if (newCartDrawer && newCartDrawer.classList.contains('is-empty')) {
            this.classList.add('is-empty');
          } else {
            this.classList.remove('is-empty');
            const newCartItems = this.querySelector('cart-drawer-items');
            if (newCartItems) newCartItems.scrollTop = scrollTop;
          }
        }
      }
      
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && sections['cart-icon-bubble']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('#cart-icon-bubble');
        if (newBubble) cartIconBubble.innerHTML = newBubble.innerHTML;
      }
      
      this.reinitFeatures();
      
    } catch (error) {
      console.error('Erreur mise à jour:', error);
    }
  }

  reinitFeatures() {
    if (this.classList.contains('is-empty')) {
      this.bindOverlay();
      return;
    }
    
    // Les noeuds viennent d'être remplacés par le serveur, aucun ne porte
    // data-initialized. Remettre ce flag à 'false' ne servait qu'à rebinder des
    // noeuds DÉJÀ liés quand deux rendus se croisaient : un clic sur "+" partait
    // alors en double (/cart/change x2). Le verrou de updateDrawerContent() rend
    // ce croisement impossible, les resets sont donc retirés et initAllFeatures()
    // redevient idempotent.
    //
    // L'intervalle du carrousel, lui, ne vit pas dans le DOM : il survit au
    // remplacement et doit être coupé avant d'en créer un nouveau.
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
      this.carouselInterval = null;
    }

    this.initAllFeatures();
  }

  /* ========================================
     TIMER
     ======================================== */

  initTimer() {
    const timerElement = document.getElementById('cart-timer');
    if (!timerElement || this.timerInterval) return;

    const TIMER_DURATION = 600;
    const STORAGE_KEY = 'cartTimerEnd';
    
    let timeLeft = TIMER_DURATION;
    const savedTime = sessionStorage.getItem(STORAGE_KEY);
    
    if (savedTime) {
      const remaining = Math.floor((parseInt(savedTime) - Date.now()) / 1000);
      if (remaining > 0) {
        timeLeft = remaining;
      } else {
        sessionStorage.setItem(STORAGE_KEY, Date.now() + (TIMER_DURATION * 1000));
      }
    } else {
      sessionStorage.setItem(STORAGE_KEY, Date.now() + (TIMER_DURATION * 1000));
    }
    
    const updateTimer = () => {
      const el = document.getElementById('cart-timer');
      if (!el) return;
      
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      el.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      
      el.style.color = timeLeft <= 60 ? '#dc2626' : '';
      
      if (timeLeft > 0) {
        timeLeft--;
      } else {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
        sessionStorage.removeItem(STORAGE_KEY);
      }
    };
    
    updateTimer();
    this.timerInterval = setInterval(updateTimer, 1000);
  }

  /* ========================================
     CARROUSEL AVIS AVEC SWIPE
     ======================================== */

  initReviewCarousel() {
    const carousel = this.querySelector('.cart-drawer__review-carousel');
    const slides = this.querySelectorAll('.cart-drawer__review-slide');
    const dots = this.querySelectorAll('.cart-drawer__review-dot');
    
    if (!carousel || slides.length === 0) return;
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    let touchStartX = 0, touchEndX = 0;
    const SWIPE_THRESHOLD = 50;
    
    const showSlide = (index) => {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentSlide = index;
      
      this.querySelectorAll('.cart-drawer__review-slide').forEach((s, i) => {
        s.classList.toggle('active', i === index);
      });
      this.querySelectorAll('.cart-drawer__review-dot').forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
    };
    
    const nextSlide = () => showSlide(currentSlide + 1);
    const prevSlide = () => showSlide(currentSlide - 1);
    
    const resetAutoPlay = () => {
      if (this.carouselInterval) clearInterval(this.carouselInterval);
      this.carouselInterval = setInterval(nextSlide, 5000);
    };
    
    // Touch events
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        diff > 0 ? nextSlide() : prevSlide();
        resetAutoPlay();
      }
    }, { passive: true });
    
    // Mouse events
    let mouseStartX = 0, isMouseDown = false;
    
    carousel.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      isMouseDown = true;
      e.preventDefault();
    });
    
    carousel.addEventListener('mouseup', (e) => {
      if (!isMouseDown) return;
      isMouseDown = false;
      
      const diff = mouseStartX - e.clientX;
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        diff > 0 ? nextSlide() : prevSlide();
        resetAutoPlay();
      }
    });
    
    carousel.addEventListener('mouseleave', () => { isMouseDown = false; });
    
    // Dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        resetAutoPlay();
      });
    });
    
    this.carouselInterval = setInterval(nextSlide, 5000);
  }

  /* ========================================
     TOGGLE ASSURANCE
     ======================================== */

  initInsuranceToggle() {
    const toggle = document.getElementById('insurance-toggle');
    const section = document.getElementById('insuranceSection');
    
    if (!toggle || toggle.dataset.initialized === 'true') return;
    toggle.dataset.initialized = 'true';
    
    toggle.addEventListener('change', async (e) => {
      const isEnabled = e.target.checked;
      
      if (section) section.style.opacity = '0.6';
      toggle.disabled = true;
      
      try {
        if (isEnabled) {
          await this.addToCart(window.INSURANCE_CONFIG.variantId);
        } else {
          await this.removeFromCart(window.INSURANCE_CONFIG);
        }
        
        if (section) section.classList.toggle('insurance-active', isEnabled);
        await this.updateDrawerContent();
        
      } catch (error) {
        console.error('Erreur:', error);
        e.target.checked = !isEnabled;
      } finally {
        if (section) section.style.opacity = '1';
      }
    });
  }

  /* ========================================
     TOGGLE UPSELL
     ======================================== */

  initUpsellToggle() {
    const toggle = document.getElementById('upsell-toggle');
    const section = document.getElementById('upsellSection');
    
    if (!toggle || toggle.dataset.initialized === 'true') return;
    toggle.dataset.initialized = 'true';
    
    toggle.addEventListener('change', async (e) => {
      const isEnabled = e.target.checked;
      
      if (section) section.style.opacity = '0.6';
      toggle.disabled = true;
      
      try {
        if (isEnabled) {
          await this.addToCart(window.UPSELL_CONFIG.variantId);
        } else {
          await this.removeFromCart(window.UPSELL_CONFIG);
        }
        
        if (section) section.classList.toggle('upsell-active', isEnabled);
        await this.updateDrawerContent();
        
      } catch (error) {
        console.error('Erreur:', error);
        e.target.checked = !isEnabled;
      } finally {
        if (section) section.style.opacity = '1';
      }
    });
  }

  /* ========================================
     HELPERS
     ======================================== */

  async addToCart(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    
    if (!response.ok) throw new Error('Erreur ajout');
    return await response.json();
  }

  async removeFromCart(config) {
    const cart = await this.getCart();
    
    let line = null;
    cart.items.forEach((item, index) => {
      if (
        item.variant_id == config.variantId ||
        item.handle === config.productHandle ||
        (config.productId && item.product_id == config.productId)
      ) {
        line = index + 1;
      }
    });
    
    if (!line) return;
    
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: 0 })
    });
    
    if (!response.ok) throw new Error('Erreur suppression');
    return await response.json();
  }

  async getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }
}

customElements.define('cart-drawer', CartDrawer);

}

/* ========================================
   CART DRAWER ITEMS
   ======================================== */

if (!customElements.get('cart-drawer-items')) {

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

}

/* ========================================
   INIT
   ======================================== */

document.addEventListener('DOMContentLoaded', () => {
  // Ce fichier est chargé DEUX fois par page (snippets/cart-drawer.liquid et
  // layout/theme.liquid), et sections/sticky-atc.liquid redispatche un faux
  // DOMContentLoaded après avoir injecté le drawer. Sans ce garde, le wrapper
  // fetch ci-dessous s'empile (2, puis 4, puis 6 couches), ce qui déclenche
  // autant de updateDrawerContent() concurrents sur chaque /cart/add.
  // La définition des custom elements est déjà protégée par customElements.get().
  if (window.__vpCartAddWatcher) return;
  window.__vpCartAddWatcher = true;

  // Fix 1.1 — Intercepter les appels /cart/add des blocs AI custom
  // Ces blocs font leur propre fetch sans passer par ProductForm,
  // donc renderContents() n'est jamais appelé et le drawer reste fermé.
  const _origFetch = window.fetch;
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = _origFetch.apply(this, arguments);

    if (url.includes('/cart/add')) {
      result.then(response => {
        if (response.ok) {
          setTimeout(() => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && !drawer.classList.contains('active')) {
              drawer.updateDrawerContent().then(() => drawer.open());
            }
          }, 250);
        }
      }).catch(() => {});
    }

    return result;
  };
});